import {Component, OnDestroy, OnInit} from '@angular/core';
import {DataStorageService} from './../../../data-storage.service';
import {AvailableComponents} from '../../../side-bar/enumAvailableComponents';
import {ApiCustomerService} from '../../../apiServices/customer/api-customer.service';
import {ContactPerson} from '../../../../models/contactPerson';

@Component({
  selector: 'app-customer-profile',
  templateUrl: './customer-profile.component.html',
  styleUrls: ['./customer-profile.component.scss']
})
export class CustomerProfileComponent implements OnInit, OnDestroy {

  allowUpdate: boolean;
  countries: {abbreviation: string, country: string}[];
  titlesDE: {title: string, langTitle: string}[];
  titlesEN: {title: string, langTitle: string}[];
  titlesFR: {title: string, langTitle: string}[];
  langs: string[];

  constructor(public dataStorageService: DataStorageService,
    private api: ApiCustomerService) {
    this.allowUpdate = false;
    this.countries = [
      {
        abbreviation: 'CHE',
        country: 'Switzerland'
      },
      {
        abbreviation: 'DEU',
        country: 'Germany'
      },
      {
        abbreviation: 'FRA',
        country: 'France'
      },
      // {
      //   abbreviation: 'POL',
      //   country: 'Poland'
      // }
    ];

    this.titlesDE = [
      {
        title: 'MR',
        langTitle: 'Herr'
      },
      {
        title: 'MS',
        langTitle: 'Frau'
      }
    ];
    this.titlesEN = [
      {
        title: 'MR',
        langTitle: 'MR'
      },
      {
        title: 'MS',
        langTitle: 'MS'
      }
    ];
    this.titlesFR = [
      {
        title: 'MR',
        langTitle: 'Monsieur'
      },
      {
        title: 'MS',
        langTitle: 'Madame'
      }
    ];
    this.langs = [
      'DE',
      'FR',
      'EN'
    ];

  }

  ngOnInit() {
    this.allowUpdate = this.dataStorageService.currentState.offerID !== 0;
    this.dataStorageService.currentComponent = AvailableComponents.CustomerProfile;
    const element = document.getElementById('customerProfile');
    element.classList.add('active');
  }

  ngOnDestroy() {
    const element = document.getElementById('customerProfile');
    element.classList.remove('active');
  }

  updateCustomer() {
    this.api.putCustomer();
  }

  addNewContactClick() {
    const newContactPerson: ContactPerson = new ContactPerson();
    this.dataStorageService.currentState.customerProfile.contacts.push(newContactPerson);
  }

  removeContactClick(i: number) {
    if (this.dataStorageService.editMode) {
      this.dataStorageService.currentState.customerProfile.contacts.splice(i, 1);
    }
    this.api.putCustomer();
  }
  setContactValue(i: number, event: any, field: string) {
    this.dataStorageService.currentState.customerProfile.contacts[i][field] = event.target.value;
    this.api.putCustomer();
  }

  showBin(): boolean {
    return this.dataStorageService.currentState.customerProfile.contacts.length > 1 ;
  }


}



// WEBPACK FOOTER //
// ./src/app/content/new-offer/customer-profile/customer-profile.component.ts